<template>
  <div>
    <div v-if="data.uploadType == 1" class="upload_type1">
      <div class="upload_list_file">
        <el-upload
          :class="`avatar-uploader ${
            uploadType != 'upload' ? 'upload_disabled' : ''
          }`"
          action
          :show-file-list="false"
          :on-change="handleChange1"
          :auto-upload="false"
          :disabled="uploadType == 'studio'"
        >
          <img v-if="imgurl" :src="imgurl" class="avatar" />
          <img
            v-else-if="data.sample"
            class="avatar"
            :src="`${resourcePath}/public/api/v1/document-type/download/${this.data.id}.${this.extname}`"
          />
          <img v-else src="../assets/sample1.jpeg" />
        </el-upload>
        <!-- <div class="select_uoload_type">
          <div>{{$t("message.DataRegistration.International.select_upload_type")}}</div>
          <el-radio v-model="uploadType"
                    label="upload">{{$t("message.DataRegistration.International.upload_by_self")}}</el-radio>
          <el-radio v-model="uploadType"
                    label="studio">{{$t("message.DataRegistration.International.upload_by_studio")}}</el-radio>
        </div> -->
      </div>
      <div class="upload_input">
        <div style="display: flex; flex-direction: row; align-items: center">
          <el-input
            v-if="uploadType == 'studio'"
            v-model="photoCode"
            :placeholder="
              $t('message.DataRegistration.International.imageCode_plc')
            "
          ></el-input>
          <img
            v-if="!$store.state.deviceTypePC"
            src="../assets/scan.png"
            alt=""
            style="width: 30px; margin-left: 10px; cursor: pointer"
            @click="showQrCodeDialog = true"
          />
        </div>
        <div class="avatar-uploader pub_btn">
          <el-button :loading="downloadPhotoLoading" @click="downloadPhoto">{{
            $t("message.upload")
          }}</el-button>
        </div>
      </div>
    </div>
    <div v-if="data.uploadType == 2" class="upload_type2_item">
      <el-row :gutter="200">
        <el-col v-if="data.id" :xs="24" :sm="12">
          <div class="upload_type2">
            <div class="upload_type2_top">
              <span>{{ $t("message.frontSide") }}</span>
              <el-upload
                :class="`avatar-uploader pub_btn`"
                action
                :show-file-list="false"
                :on-change="handleChange1"
                :auto-upload="false"
              >
                <el-button type="primary">{{ $t("message.upload") }}</el-button>
              </el-upload>
            </div>
            <div class="upload_type2_file">
              <el-upload
                :class="`avatar-uploader`"
                action
                :show-file-list="false"
                :on-change="handleChange1"
                :auto-upload="false"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <img
                  v-else-if="data.sample"
                  class="avatar"
                  :src="`${resourcePath}/public/api/v1/document-type/download/${this.data.id}.${this.extname}`"
                />
                <img v-else src="../assets/logo.png" />
              </el-upload>
            </div>
          </div>
        </el-col>
        <el-col v-if="data.reverseSide" :xs="24" :sm="12">
          <div class="upload_type2">
            <div class="upload_type2_top">
              <span>{{ $t("message.reverseSide") }}</span>
              <el-upload
                :class="`avatar-uploader pub_btn`"
                action
                :show-file-list="false"
                :on-change="handleChange2"
                :auto-upload="false"
              >
                <el-button type="primary">{{ $t("message.upload") }}</el-button>
              </el-upload>
            </div>
            <div class="upload_type2_file">
              <el-upload
                :class="`avatar-uploader`"
                action
                :show-file-list="false"
                :on-change="handleChange2"
                :auto-upload="false"
              >
                <img v-if="imageUrl2" :src="imageUrl2" class="avatar" />
                <img
                  v-else-if="data.reverseSide.sample"
                  class="avatar"
                  :src="`${resourcePath}/public/api/v1/document-type/download/${this.data.reverseSide.id}.${this.extname}`"
                />
                <img v-else src="../assets/logo.png" />
              </el-upload>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="isPreview">
      <img :src="imgurl" style="width: 100%" />
    </div>

    <!-- 剪切图片的弹框-->
    <div class="upload-dialog">
      <el-dialog
        :title="$t('message.imgEdit')"
        :visible.sync="isShowCropper"
        :close-on-click-modal="false"
        fullscreen
        :show-close="false"
        width="1000px"
      >
        <div class="vue-cropper-box">
          <div class="vue-cropper-content">
            <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="option.info"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixedBox="option.fixedBox"
              @realTime="realTime"
              @imgLoad="imgLoad"
            ></vueCropper>
          </div>
        </div>
        <span slot="footer">
          <div class="operate-wrap">
            <el-button type="primary" plain @click="changeScale(1)">{{
              $t("message.enlarge")
            }}</el-button>
            <el-button type="primary" plain @click="changeScale(-1)">{{
              $t("message.narrow")
            }}</el-button>
            <el-button type="primary" @click="onCubeImg">{{
              $t("message.confirm")
            }}</el-button>
            <el-button type="info" @click="cancleCropper">{{
              $t("message.cancel")
            }}</el-button>
          </div>
        </span>
      </el-dialog>
    </div>
    <!-- 掃二維碼 -->
    <Qrcode
      v-if="showQrCodeDialog"
      @save="saveQrcode"
      @close="showQrCodeDialog = false"
    ></Qrcode>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import { resourcePath } from "../api/axios";
import DrivIntApplicationAPI from "../api/DrivIntApplicationAPI";
import Qrcode from "./Qrcode";
export default {
  components: { VueCropper, Qrcode },
  data() {
    return {
      resourcePath: resourcePath,
      returnData: null,
      imgurl: null,
      file1: null,
      file2: null,
      isShowCropper: false,
      fileImg: "",
      edit: null,
      imageUrl: "",
      imageUrl2: "",
      uploadType: "studio",
      photoCode: null,
      downloadPhotoLoading: false,
      showQrCodeDialog: false,
    };
  },
  props: {
    isPreview: {
      type: Boolean,
      required: false,
      default: true,
    },
    isAutoDownload: {
      type: Boolean,
      required: false,
      default: false,
    },
    returnType: {
      type: String,
      required: false,
      default: "base64",
      validator: (value) => {
        return ["base64", "file"].indexOf(value) !== -1;
      },
    },
    widths: {
      type: [String, Number],
      required: false,
      default: 700,
    },
    quality: {
      type: [String, Number],
      required: false,
      default: 0.618,
    },
    data: {},
  },
  computed: {
    extname() {
      const filename = (this.data.sample && this.data.sample.filename) || null;
      if (!filename || typeof filename != "string") {
        return "";
      }
      let a = filename.split("").reverse().join("");
      let b = a.substring(0, a.search(/\./)).split("").reverse().join("");
      return b;
    },
    option() {
      const width = this.$store.state.isMobile ? 300 : 500;
      return {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 剪切后的图片质量（0.1-1）
        full: true, // 输出原图比例截图 props名full
        outputType: "png", // 裁剪生成额图片的格式
        canMove: true, // 能否拖动图片
        original: false, // 上传图片是否显示原始宽高
        canMoveBox: false, // 能否拖动截图框
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: width, // 默认生成截图框宽度
        autoCropHeight: width / 1.58, // 默认生成截图框高度
        fixed: true, // 是否开启截图框宽高固定比例
        fixedBox: true, // 截图框固定大小
        fixedNumber: [1.58, 1], // 截图框的宽高比例
        // centerBox:true // 截图框是否被限制在图片里面
      };
    },
  },
  methods: {
    base64ToBlob(code) {
      let parts = code.split(";base64,");
      let contentType = parts[0].split(":")[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    downloadFile(fileName, content) {
      let aLink = document.createElement("a");
      let blob = this.base64ToBlob(content); // new Blob([content]);
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true); // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      aLink.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      ); // 兼容火狐
    },
    handleChange1(file, fileList) {
      console.log("file: ", file);
      console.log("fileList: ", fileList);
      this.option.img = URL.createObjectURL(file.raw);
      // 驗證文件格式
      if (!this.utils.uploadExtCheck(file.name, this.data.fileExtensions)) {
        return false;
      }
      // 驗證文件大小限制
      if (!this.utils.fsLimit(file.size, this.data.maxFileSize)) {
        return false;
      }

      if (fileList.length > 0) {
        this.fileList2 = [fileList[fileList.length - 1]];
        this.$emit("change1", this.fileList2[0]);
      }
      this.edit = 1;
      this.isShowCropper = true;
      // this.file1 = file;
    },
    handleChange2(file, fileList) {
      this.option.img = URL.createObjectURL(file.raw);
      // 驗證文件格式
      if (
        !this.utils.uploadExtCheck(
          file.name,
          this.data.reverseSide.fileExtensions
        )
      ) {
        return false;
      }
      // 驗證文件大小限制
      if (!this.utils.fsLimit(file.size, this.data.reverseSide.maxFileSize)) {
        return false;
      }
      if (fileList.length > 0) {
        this.fileList2 = [fileList[fileList.length - 1]];
        this.$emit("change2", this.fileList2[0]);
      }
      this.edit = 2;
      this.isShowCropper = true;
    },
    // 照相館上傳
    imgCodeUpload(file, fileList) {
      // if (!this.photoCode) {
      //   this.$message({
      //     message: this.$t('message.DataRegistration.International.inputStudioCode'),
      //     type: 'warning'
      //   });
      // } else {
      // this.$message({
      //   message: this.$t('message.upload_success'),
      //   type: 'success'
      // });
      this.option.img = URL.createObjectURL(file.raw);
      // 驗證文件格式
      if (!this.utils.uploadExtCheck(file.name, this.data.fileExtensions)) {
        return false;
      }
      // 驗證文件大小限制
      if (!this.utils.fsLimit(file.size, this.data.maxFileSize)) {
        return false;
      }
      if (fileList.length > 0) {
        this.fileList2 = [fileList[fileList.length - 1]];
        this.$emit("change2", this.fileList2[0]);
      }
      this.edit = 1;
      this.upFile([file.raw]);
    },
    upFile(files) {
      if (this.returnType !== "file") {
        console.log(files);
        this.filesToInstances(files);
      } else {
        this.returnData = event.target.files;
        this.returnRes();
      }
    },
    filesToInstances(files) {
      const length = files.length;
      let instances = [];
      let finished = 0;
      files.forEach((file, index) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          const image = new Image();
          image.src = e.target.result;
          image.onload = () => {
            // 图片实例化成功后存起来
            instances[index] = image;
            finished++;
            if (finished === length) {
              this.drawImages(instances);
            }
          };
        };
      });
    },
    drawImages(images) {
      const width = this.widths;
      const heights = images.map((item) => (width / item.width) * item.height);
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = heights.reduce((total, current) => total + current);
      const context = canvas.getContext("2d");

      let y = 0;

      images.forEach((item, index) => {
        const height = heights[index];
        context.drawImage(item, 0, y, width, height);
        y += height;
      });
      const base64Url = canvas.toDataURL("image/jpeg", this.quality);

      this.dealImages(base64Url);
      if (this.returnType == "base64" && this.isAutoDownload) {
        this.downloadFile(this.createFileName(), base64Url);
      }
    },
    dealImages(url) {
      this.imgurl = url;
      // this.returnData = url;
      this.returnData = this.base64ToBlob(url);
      this.returnRes();
    },
    returnRes() {
      if (this.data.uploadType === 2) {
        let dataArr = [{ file: this.file1, code: this.data.code }];
        if (this.data.reverseSide) {
          dataArr.push({ file: this.file2, code: this.data.reverseSide.code });
        }
        this.$emit("getRes", dataArr);
      } else {
        this.$emit("getRes", [{ file: this.returnData, code: this.data.code }]);
      }
    },
    createFileName() {
      return "图片拼接" + new Date().getTime();
    },

    /**
     * 圖片裁減相關
     */
    cancleCropper() {
      //取消截图
      this.isShowCropper = false;
    },
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    imgLoad(msg) {
      // console.log("imgLoad");
      // console.log(msg);
    },
    // 实时预览函数
    realTime(data) {
      // console.log("realTime");
      this.previews = data;
    },
    onCubeImg() {
      //剪切上传
      // 获取cropper的截图的base64 数据
      this.$refs.cropper.getCropData((data) => {
        // this.fileinfo.url = data;

        //先将显示图片地址清空，防止重复显示
        this.option.img = "";
        //将剪裁后base64的图片转化为file格式
        let file = this.convertBase64UrlToBlob(data);
        this.fileImg = URL.createObjectURL(file);
        var formData = new FormData();
        formData.append("file", file);
        formData.append("isFile", "1");
        console.log("file:", file);
        this.imgUrl = file;
        if (this.edit == 1) {
          this.file1 = file;
          this.imageUrl = this.fileImg;
          this.isShowCropper = false;
          this.upFile([this.file1]);
        } else {
          this.file2 = file;
          this.imageUrl2 = this.fileImg;
          this.isShowCropper = false;
          this.upFile([this.file2]);
        }
        // if (this.data.uploadType == 1) {
        // this.upFile([this.file1]);
        // }
        // if (this.data.uploadType == 2 && this.file1 && this.file2) {
        //   this.upFile([this.file1, this.file2]);
        // }
        this.isShowCropper = false;
      });
    },
    // 将base64的图片转换为file文件
    convertBase64UrlToBlob(urlData) {
      let bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      let ab = new ArrayBuffer(bytes.length);
      let ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], { type: "image/jpeg" });
    },
    // 下載一寸半彩照
    downloadPhoto() {
      if (!this.photoCode) {
        this.$message({
          type: "warning",
          message: this.$i18n.t(
            "message.DataRegistration.International.inputStudioCode"
          ),
        });
        return false;
      }
      this.downloadPhotoLoading = true;
      DrivIntApplicationAPI.photo(this.photoCode)
        .then((res) => {
          this.downloadPhotoLoading = false
          const src =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(res).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
          this.imgurl = src;
          this.$message({
            type: "success",
            message: this.$i18n.t("message.upload_success"),
          });
          const file = this.base64ToBlob(src);
          this.$emit("getRes", [{ file: file, code: this.data.code }]);
        })
        .catch((err) => {
          this.downloadPhotoLoading = false
          // 將arraybuffer轉化為json
          if (err.status === 404) {
            this.$message({
              type: "error",
              message: this.$i18n.t("message.ErrorMessage.PHOTO_NO_ERROR"),
            });
            return false;
          }
          let enc = new TextDecoder("utf-8");
          const errData = JSON.parse(enc.decode(new Uint8Array(err.data)));
          console.log(errData);
          this.$error({ ...errData, status: err.status });
        })
    },
    saveQrcode(val) {
      this.photoCode = val;
      this.showQrCodeDialog = false;
    },
  },
};
</script>

<style>
.vue-cropper-box {
  height: 100%;
}
.vue-cropper-content {
  height: 100%;
}
</style>
<style lang="scss" scoped>
.upload_list_file {
  padding: 16px 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background: #f2f2f2;
  padding: 10px;
  border-radius: 10px;
  max-width: 200px;
  margin: 20px 0;
  .avatar-uploader {
    margin-right: 24px;
    background: #fff;
    border-radius: 10px;
  }
  /deep/.el-upload {
    width: 200px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 280px;
  }
}
.avatar-uploader img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  background: #fff;
  border-radius: 10px;
  margin-right: 24px;
}
.avatar {
  width: 178px;
  display: block;
  border-radius: 10px;
  // margin-right: 24px;
}
/deep/.upload_disabled {
  .el-upload {
    cursor: not-allowed;
    opacity: 0.8;
  }
}
.upload_input {
  max-width: 450px;
  width: 100%;
  margin-bottom: 24px;
  // display: flex;
  // flex-direction: row;
  // align-items: center;
  /deep/.el-input {
    flex: 1;
  }
  .pub_btn {
    margin-top: 10px;
  }
  .pub_btn .el-button {
    min-width: 100px;
    margin-left: 0;
  }
}
.select_uoload_type {
  line-height: 35px;
  font-size: 18px;
}
.upload_type2 {
  margin-bottom: 24px;
}
.upload_type2_top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 14px 0;
  .pub_btn {
    margin-top: 0;
  }
}

.upload_type2_file {
  border-radius: 10px;
  border: 1px solid #d7d7d7;
  text-align: center;
  overflow: hidden;
  .avatar-uploader {
    height: 209px;
  }
  /deep/.el-upload,
  .avatar-uploader-icon {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content: center;
    flex-wrap: wrap;
  }
  .avatar {
    width: auto;
    height: auto;
    max-width: 100%;
    // max-height: 170px;
    margin: auto;
    
  }
}
.upload-dialog {
  /deep/.el-dialog {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    .el-dialog__header {
      text-align: center;
    }
    .el-dialog__body {
      flex: 1;
      padding: 0 20px;
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
}

@media screen and (max-width: 767px) {
  .upload_list_file {
    flex-wrap: wrap;
  }
  .upload_list_file .avatar-uploader {
    margin: 0 auto;
  }
}
</style>